import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Routes that need detail data from AbaNinja (contracts, activityTypes, products, invoices)
const DETAIL_DATA_ROUTES = [
  '/main-timetracking',
  '/main-dashboard',
];

// Routes that need time tracking to be active
const TIME_TRACKING_ROUTES = [
  '/main-timetracking',
  '/main-dashboard',
];

// Routes that need local projects
const LOCAL_PROJECTS_ROUTES = [
  '/main-timetracking',
];

export const useRouteDataLoader = (loadDetailData) => {
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const needsDetail = DETAIL_DATA_ROUTES.some(route => path.startsWith(route));
    if (needsDetail) {
      loadDetailData();
    }
  }, [path, loadDetailData]);

  return {
    needsTimeTracking: TIME_TRACKING_ROUTES.some(route => path.startsWith(route)),
    needsLocalProjects: LOCAL_PROJECTS_ROUTES.some(route => path.startsWith(route)),
  };
};
